import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../../helpers/fackBackend_Helper";

function* inventoryTransferResponse({ payload: { data } }) {
  try {
    const response = yield call( addData, "/API/V1/Inventory/InventorySimTransfer", data, );
    if (response?.statusCode == 1200) {
      yield put(actions.inventoryTransferSuccess(response?.message));
    } else {
      yield put(actions.inventoryTransferError(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.inventoryTransferError(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.INVENTORY_TRANSFER, inventoryTransferResponse)]);
}
